export enum ETableAction {
  delete = 'delete',
  edit = 'edit',
  copy = 'copy',
  confirmEdit = 'confirmEdit',
  cancelEdit = 'cancelEdit',
}

export interface HeadCell<T> {
  id: keyof T
  label: string
  colSpan?: number
  isSortable?: boolean
}

export type TActionsHeadCell<T> = Omit<HeadCell<T>, 'id'> & {
  id: EActionsKey.actions
}

export type THeadCellWithActions<T> = Array<HeadCell<T> | TActionsHeadCell<T>>

export enum EColumnSort {
  asc = 'asc',
  desc = 'desc',
}

export enum EActionsKey {
  actions = 'actions',
}
